import { uiActionTypes as actionType } from 'src/constants/actionTypes';

export const startAction = () => ({ type: actionType.START_ACTION });
export const stopAction = () => ({ type: actionType.STOP_ACTION });
